import $ from 'jquery';
import Inputmask from "inputmask";

export function form() {
  const textareaWrapperElement = document.querySelector('#textarea-counter');
  const inputPhoneElement = document.querySelector('.input-item__el.tel');
  const checkboxElement = document.querySelector('.popup-form__bottom input[type="checkbox"]');
  const buttonElement = document.querySelector('.popup-form__bottom button.button');

  if (textareaWrapperElement) {
    const textareaElement = textareaWrapperElement.querySelector('textarea');
    const counterElement = textareaWrapperElement.querySelector('.input-item__counter-val');

    if (counterElement && textareaElement) {
      textareaElement.addEventListener('input', function () {
        const text = this.value;
        const count = text.length;

        counterElement.textContent = count;
      });
    }
  }

  if (inputPhoneElement) {
    const im = new Inputmask({
      mask: "+38(999)999-99-99",
      'autoUnmask': true
    });

    im.mask(inputPhoneElement);
  }

  if (checkboxElement && buttonElement) {
    checkboxElement.addEventListener('change', function () {
      if (this.checked) {
        buttonElement.removeAttribute('disabled');
      } else {
        buttonElement.setAttribute('disabled', 'true');
      }
    });
  }
}


// WEBPACK FOOTER //
// app/scripts/components/form.js